/* global PDFJS */

/**
 * This Assumes that PDF.JS has been imported on the page and is in global
 * scope.
 */

/**
 * Will take a PDF object and draw it to an in-memory canvas. The canvas
 * .toDataURL() method will be used to create an image element that is returned
 * by this function.
 *
 * The reason an image is used to display the page rather than the canvas is
 * to take advantage of the native image resizing when the window is resized.
 * This is only to replace the current pdf-to-image system and is not inteded
 * to be a full rewrite of the PerformYard PDFs.
 *
 * @param {object} pdf - PDFDocumentProxy object
 * @param {number} pageNumber - page number to render
 */
const pageToImage = async (pdf, pageNumber) => {
	// get the PDFPageProxy object
	const page = await pdf.getPage(pageNumber);

	// create the in-memory canvas
	let canvas = document.createElement("canvas");

	// set page scaled based on expected image width
	const containerWidth = 1000;
	const viewport = page.getViewport(containerWidth / page.getViewport(1.0).width);

	//
	// Prepare canvas using PDF page dimensions
	//
	const context = canvas.getContext("2d");
	canvas.height = viewport.height;
	canvas.width = viewport.width;

	//
	// Render PDF page into canvas context
	//
	await page.render({ canvasContext: context, viewport });

	// convert image to jpeg
	const fullQualityImageData = canvas.toDataURL("image/jpeg", 1.0);

	// render image
	const image = document.createElement("img");
	image.src = fullQualityImageData;
	image.style.width = "100%";
	image.className = "pdf-image";

	// free the canvas
	canvas = null;

	// return image element
	return image;
};

const pdfToImages = async (pdfURL, callback) => {
	// fetch the pdf
	const pdf = await PDFJS.getDocument(pdfURL);

	// get page count
	const pageCount = pdf.numPages;

	// page promises
	const pages = [];

	// render each page
	for (let ii = 0; ii < pageCount; ii += 1) {
		const pageNumber = ii + 1;
		pages.push(pageToImage(pdf, pageNumber));
	}

	// promise all
	const renderedPages = await Promise.all(pages);

	// callback
	callback(pdf, renderedPages);
};

export default pdfToImages;
